import { useState, useEffect } from 'react';
import { Wifi, WifiOff, Settings } from 'lucide-react';
import PWATroubleshoot from './PWATroubleshoot';
import usePWA from '../../hooks/usePWA';

const PWAStatus = () => {
  const { isOnline, isInstalled } = usePWA();
  const [showStatus, setShowStatus] = useState(false);
  const [showTroubleshoot, setShowTroubleshoot] = useState(false);

  useEffect(() => {
    // Auto-show status when offline (removed update available trigger)
    if (!isOnline) {
      setShowStatus(true);
      const timer = setTimeout(() => setShowStatus(false), 8000);
      return () => clearTimeout(timer);
    }
  }, [isOnline]);

  // Always render in PWA mode, but conditionally show elements
  const shouldShowBanner = showStatus || !isOnline;

  return (
    <>
      <div className="fixed top-0 left-0 right-0 z-50">
        {/* Offline Status */}
        {!isOnline && (
          <div className="bg-amber-500 text-white px-4 py-2 text-sm flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <WifiOff size={16} />
              <span>You're offline • Some features may not be available</span>
            </div>
            {isInstalled && (
              <button
                onClick={() => setShowTroubleshoot(true)}
                className="text-white hover:text-amber-100"
              >
                <Settings size={16} />
              </button>
            )}
          </div>
        )}

        {/* Online Status (briefly shown when coming back online) */}
        {isOnline && showStatus && (
          <div className="bg-emerald-500 text-white px-4 py-2 text-sm flex items-center justify-center space-x-2">
            <Wifi size={16} />
            <span>Back online</span>
          </div>
        )}

        {/* PWA Debug Button - Only show in installed PWA */}
        {isInstalled && isOnline && !showStatus && (
          <div className="fixed top-4 right-4 z-40">
            <button
              onClick={() => setShowTroubleshoot(true)}
              className="bg-slate-600 bg-opacity-75 text-white p-2 rounded-full hover:bg-opacity-90 transition-opacity"
              title="PWA Troubleshoot"
            >
              <Settings size={16} />
            </button>
          </div>
        )}
      </div>

      {showTroubleshoot && (
        <PWATroubleshoot onClose={() => setShowTroubleshoot(false)} />
      )}
    </>
  );
};

export default PWAStatus;